import { useEffect, useRef, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const fields = [
  ["calendly_url", "Link Calendly (chiamata conoscitiva)", "https://calendly.com/tuo-nome/chiamata"],
  ["instagram_url", "Link profilo Instagram", "https://www.instagram.com/tuo_profilo"],
  ["tiktok_url", "Link TikTok (facoltativo)", "https://www.tiktok.com/@tuo_profilo"],
  ["whatsapp_url", "Link WhatsApp (facoltativo)", "https://wa.me/39..."],
];

export default function SettingsPanel({ call }) {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  const loaded = useRef(false);
  useEffect(() => {
    if (loaded.current) return;
    loaded.current = true;
    call("get", "/settings").then(setS).catch(() => toast.error("Impossibile caricare le impostazioni"));
  }, [call]);
  if (!s) return null;

  const setT = (i, k, v) => setS({ ...s, testimonials: s.testimonials.map((t, j) => (j === i ? { ...t, [k]: v } : t)) });

  const save = async () => {
    setSaving(true);
    try {
      setS(await call("put", "/admin/settings", s));
      toast.success("Salvato");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore nel salvataggio");
    }
    setSaving(false);
  };

  return (
    <div className="bg-white border border-[#E5E1D8] rounded-2xl p-5 space-y-6" data-testid="settings-panel">
      <div className="grid sm:grid-cols-2 gap-4">
        {fields.map(([k, label, ph]) => (
          <div key={k} className="space-y-1.5">
            <Label htmlFor={k}>{label}</Label>
            <Input id={k} data-testid={`settings-${k.replace("_", "-")}-input`} placeholder={ph} value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} />
          </div>
        ))}
      </div>
      <div>
        <div className="flex items-center justify-between">
          <div>
            <p className="font-semibold">Testimonianze</p>
            <p className="text-xs text-[#5A625C]">La sezione appare sulla pagina solo quando ne aggiungi almeno una (usa solo testimonianze vere, con il consenso della cliente).</p>
          </div>
          <Button size="sm" variant="outline" data-testid="settings-add-testimonial-button" onClick={() => setS({ ...s, testimonials: [...s.testimonials, { name: "", text: "", result: "" }] })}>
            <Plus className="w-4 h-4 mr-1" /> Aggiungi
          </Button>
        </div>
        <div className="mt-4 space-y-4">
          {s.testimonials.map((t, i) => (
            <div key={i} className="border border-[#E5E1D8] rounded-xl p-4 space-y-3" data-testid={`settings-testimonial-${i}`}>
              <div className="grid sm:grid-cols-2 gap-3">
                <Input placeholder="Nome (es. Giulia, 34 anni)" value={t.name} onChange={(e) => setT(i, "name", e.target.value)} data-testid={`settings-testimonial-name-${i}`} />
                <Input placeholder="Risultato (es. -6 cm di vita)" value={t.result} onChange={(e) => setT(i, "result", e.target.value)} data-testid={`settings-testimonial-result-${i}`} />
              </div>
              <Textarea placeholder="Cosa dice la cliente" value={t.text} onChange={(e) => setT(i, "text", e.target.value)} data-testid={`settings-testimonial-text-${i}`} />
              <Button size="sm" variant="ghost" className="text-[#C05746]" data-testid={`settings-testimonial-remove-${i}`} onClick={() => setS({ ...s, testimonials: s.testimonials.filter((_, j) => j !== i) })}>
                <Trash2 className="w-4 h-4 mr-1" /> Rimuovi
              </Button>
            </div>
          ))}
        </div>
      </div>
      <Button onClick={save} disabled={saving} data-testid="settings-save-button" className="bg-[#C05746] hover:bg-[#A54A3B]">
        {saving ? "Salvataggio…" : "Salva impostazioni"}
      </Button>
    </div>
  );
}
